module.exports = __webpack_public_path__ + "fonts/WorkSans-Light.95a5a89.eot";